import React from "react";
import { Accordion, Badge, Table } from "react-bootstrap";
import { BsBug, BsBugFill, BsInfo, BsShieldFillCheck } from "react-icons/bs";
import AdminContainer from "../admin-components/AdminContainer";
import { H1, Section } from "../components/StyledComponents";
import { AccordionComp } from "../components/StyledComponents";
interface Props {}

const Updates: React.FC<Props> = () => {
  return (
    <AdminContainer>
        <Section>
            <H1>Evaluation Platform - updates</H1>
            <AccordionComp title="Update - 05.08.2025">
                <p>This update contains style improvements, bug fixes and new features: </p>
                <Table responsive className="table">
                    <tbody>
                        <tr>
                            <th className="text-info">Components/Route &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                            <th className="text-info">Update Description</th>
                            <th className="text-info">Severity &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                            <th className="text-info">Type &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                        </tr>
                        <tr>
                            <td><strong>Manage Evaluation Periods</strong></td>
                            <td>Sorting is fixed - from the newest to latest<br />
                            </td>
                            <td><Badge className="bg-success">Low</Badge></td>
                              <td><BsShieldFillCheck /> Feature</td>
                        </tr>
                       
                        <tr>
                            <td><strong>Create Appraisal Document</strong></td>
                            <td>Stability of the component was significantly improved.<br />
                            </td>
                            <td><Badge className="bg-warning">Moderate</Badge></td>
                            <td><BsBug /> Bug</td>
                        </tr>
                        <tr>
                            <td><strong>Evaluation - Appraisal Document</strong></td>
                            <td>Load historical evaluations for the colleague - naming fix. <br />
                            </td>
                            <td><Badge className="bg-success">Low</Badge></td>
                            <td><BsBug /> Bug</td>
                        </tr>
                        <tr>
                            <td><strong>Evaluation - Appraisal Document</strong></td>
                            <td>Periods that were already applied to the colleague can not be selected anymore!<br />
                            </td>
                            <td><Badge className="bg-warning">Moderate</Badge></td>
                            <td><BsShieldFillCheck /> Feature</td>
                        </tr>
                        <tr>
                            <td><strong>Team statistics and assesment</strong></td>
                            <td>Team statistics and assesment were completely re-done. Now they support all possible features.<br />
                            </td>
                            <td><Badge className="bg-danger">Critical</Badge></td>
                            <td><BsShieldFillCheck /> Feature</td>
                        </tr>
                        
                       
                    </tbody>
                </Table>
            </AccordionComp>
           
        </Section>
    </AdminContainer>
  );
};

export default Updates;
